var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsUpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2022 3.00002H12.1978C7.34572 3.00002 3.40002 6.94681 3.40002 11.8C3.40002 13.725 4.02042 15.5092 5.07532 16.9579L4 21L7.36112 19.1458C8.75262 20.0676 10.4125 20.6 12.2022 20.6C17.0543 20.6 21 16.6521 21 11.8C21 6.94791 17.0543 3.00002 12.2022 3.00002Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1126 15.591C16.905 16.192 16.0812 16.6904 15.4241 16.836C14.9745 16.9341 14.3873 17.0124 12.4106 16.1721C9.88211 15.0981 8.25384 12.4637 8.12693 12.2928C8.0054 12.1218 7.10522 10.8978 7.10522 9.63191C7.10522 8.36599 7.73223 7.74957 7.98497 7.48492C8.19253 7.26769 8.53561 7.16844 8.86471 7.16844C8.97118 7.16844 9.0669 7.17396 9.15294 7.17837C9.40567 7.18939 9.53258 7.20483 9.69928 7.61394C9.90685 8.1267 10.4123 9.39262 10.4725 9.52274C10.5339 9.65287 10.5952 9.8293 10.5091 10.0002C10.4285 10.1767 10.3575 10.2549 10.2306 10.4049C10.1037 10.5549 9.98321 10.6696 9.8563 10.8306C9.74015 10.9706 9.60894 11.1206 9.7552 11.3797C9.90147 11.6333 10.4069 12.4791 11.1512 13.1584C12.1116 14.0351 12.8902 14.3152 13.1688 14.4342C13.3763 14.5225 13.6237 14.5015 13.7753 14.3361C13.9679 14.1233 14.2055 13.7704 14.4475 13.4231C14.6196 13.1738 14.8368 13.143 15.0648 13.2312C15.2971 13.3139 16.5264 13.9369 16.7792 14.0659C17.0319 14.1961 17.1986 14.2578 17.2599 14.367C17.3201 14.4762 17.3201 14.9889 17.1126 15.591Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsUpp);
export default __webpack_public_path__ + "static/media/WhatsUpp.bccba7d89ec941257364b9e76a6322c1.svg";
export { ForwardRef as ReactComponent };